import {visionTool} from '@sanity/vision'
import {defineConfig} from 'sanity'
import {structureTool} from 'sanity/structure'

import {muxInput} from './src/_exports'

export default defineConfig({
  name: 'sanity-plugin-mux-input',
  projectId: 'lb871prh',
  dataset: 'production',
  schema: {
    types: [
      {
        title: 'Trailer',
        name: 'trailer',
        type: 'document',
        fields: [
          {title: 'Title', name: 'title', type: 'string'},
          {
            title: 'Video',
            name: 'video',
            type: 'mux.video',
          },
        ],
      },
    ],
  },
  plugins: [
    structureTool(),
    muxInput({
      video_quality: 'plus',
      max_resolution_tier: '2160p',
      static_renditions: ['highest'],
      defaultAutogeneratedSubtitleLang: 'en',
    }),
    visionTool(),
  ],
})
